import { Link } from "react-router-dom";
import { Activity, Mail, Shield } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-200 bg-zinc-50 mt-24">
      <div className="container-x py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="w-8 h-8 rounded-md flex items-center justify-center" style={{ background: "var(--ink)" }}>
              <Activity className="w-4 h-4" style={{ color: "var(--gold)" }} />
            </span>
            <span className="font-extrabold text-lg">Sonote™</span>
          </div>
          <p className="text-sm text-zinc-600 max-w-xs">
            Protecting the people behind the probe. Built by clinicians, for clinicians.
          </p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.18em] font-bold text-zinc-500 mb-3">Platform</h4>
          <ul className="space-y-2 text-sm text-zinc-700">
            <li><Link to="/features">Features</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.18em] font-bold text-zinc-500 mb-3">Compliance</h4>
          <ul className="space-y-2 text-sm text-zinc-700">
            <li className="flex items-center gap-2"><Shield className="w-4 h-4" style={{ color: "var(--gold)" }} />HIPAA-ready</li>
            <li className="flex items-center gap-2"><Shield className="w-4 h-4" style={{ color: "var(--gold)" }} />GDPR-ready</li>
            <li className="flex items-center gap-2"><Shield className="w-4 h-4" style={{ color: "var(--gold)" }} />PIPEDA-ready</li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.18em] font-bold text-zinc-500 mb-3">Contact</h4>
          <a href="mailto:hello@sonote.app" className="flex items-center gap-2 text-sm text-zinc-700">
            <Mail className="w-4 h-4" /> hello@sonote.app
          </a>
        </div>
      </div>
      <div className="border-t border-zinc-200 py-6 text-center text-xs text-zinc-500">
        © {new Date().getFullYear()} Sonote™. All rights reserved.
      </div>
    </footer>
  );
}
